import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

/**
 * Reusable logic to handle deep links from push notifications or in-app inbox
 */
export const resolveNotificationLink = async (targetUrl, navigate) => {
    if (!targetUrl || typeof targetUrl !== 'string') return;

    // 1. Handle Custom App Scheme (budlee://...)
    if (targetUrl.startsWith('budlee://')) {
        const internalPath = targetUrl.replace('budlee://', '/');
        navigate(internalPath);
        return;
    }

    // 2. Handle Internal Paths (/student/...) or Hash Paths (#/...)
    if (targetUrl.startsWith('/') || targetUrl.startsWith('#/')) {
        const path = targetUrl.startsWith('#/') ? targetUrl.substring(1) : targetUrl;
        navigate(path);
        return;
    }

    // 3. Handle Absolute URLs
    if (targetUrl.startsWith('http')) {
        const webUrlHost = (window.__ENV?.REACT_APP_WEB_URL || '').replace(/^https?:\/\//, '');
        const isInternalDomain = (webUrlHost && targetUrl.includes(webUrlHost)) || 
                               targetUrl.includes(window.location.hostname);
        
        if (isInternalDomain) {
            try {
                const urlObj = new URL(targetUrl);
                // In HashRouter setup, if the hash starts with #/, use the hash routing path directly
                if (urlObj.hash && urlObj.hash.startsWith('#/')) {
                    navigate(urlObj.hash.substring(1));
                } else {
                    navigate(urlObj.pathname + urlObj.search + urlObj.hash);
                }
                return;
            } catch (e) { /* fallback */ }
        }

        // Open truly external URLs in the browser
        if (Capacitor.isNativePlatform()) {
            try {
                await Browser.open({ url: targetUrl });
            } catch (e) {
                window.location.href = targetUrl;
            }
        } else {
            window.open(targetUrl, '_blank');
        }
    } else {
        // Final fallback
        window.location.href = targetUrl;
    }
};
